import React from "react";
import HoverTrigger from "./HoverTrigger";

import './Folio.css';
import Hover, {InspectHover} from "./Hover";

const Folio = () => {

    const handleTrigger = (e: MouseEvent) => {
        console.log(e);
        const element = e.target as HTMLElement;
        // add hover above the element
        element.classList.add('folio-hover');
        // remove hover after 1 second
        setTimeout(() => {
            element.classList.remove('folio-hover');
        }, 1000);
    }

    // random portfolio
    return (
        <>
            <div className="white-box">
                {/*<HoverTrigger onTrigger={handleTrigger}>*/}
                <InspectHover>
                    I am the hover
                    <div style={{height: 80, width: 100, background: '#ad3ed9'}}>
                    </div>
                </InspectHover>
            </div>
        </>
    )
}

export default Folio;